export const BINDER_WALL_COLUMNS = "binderWallColumns";
export const DEFAULT_PROFILE_LANDING_TABS = "defaultQuickProfileLandingTabs";
export const DEFAULT_START_TARGET = "defaultStartTarget";
export const DEFAULT_TARGET_COLUMN_ORDER = "defaultTargetColumnOrder";
export const DEFAULT_TARGET_COLUMN_WIDTHS = "defaultTargetColumnWidths";
export const DEFAULT_TARGET_FIELDS = "defaultTargetFields";
export const DISABLE_CHANGE_BINDER_WARNING = "disableChangeBinderWarning";
export const DISABLE_INTRO = "disableIntro";
export const FILTERS_OPEN_DEFAULT = "showTabFilters2";
export const TARGET_LAYOUT = "targetLayout";
